import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationOpenTofuMigrateArgs, OpenTofuMigrateResult } from "types/generated";

type FetchOpenTofuMigrateData = {
  openTofuMigrate: OpenTofuMigrateResult;
};

export const OPEN_TOFU_MIGRATE: TypedDocumentNode<
  FetchOpenTofuMigrateData,
  MutationOpenTofuMigrateArgs
> = gql`
  mutation OpenTofuMigrate($input: SearchInput!, $target: StackVendor!, $triggerRun: Boolean) {
    openTofuMigrate(input: $input, target: $target, triggerRun: $triggerRun) {
      queued
    }
  }
`;
